
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'LoaderComponent',
  props: {
    sizeLarge: { type: Boolean, default: true }
  }
});
